import InteractiveGrid from "./interactive-grid.js";
import { child } from "./dom.js";

export default class KeyboardGrid extends InteractiveGrid {
	constructor(...args) {
		super(...args);
		this.wallButtons = [];
		this.allWallButtons = [];
		for (const { x, y, xyParity, td } of this.allCells()) {
			if (xyParity || !x || !y) continue;
			if (!this.wallButtons[y]) this.wallButtons[y] = [];
			const b = child(td, "button.wall-button");
			this.wallButtons[y][x] = b;
			b.dataset.x = x;
			b.dataset.y = y;
			b.innerText = "Add wall";
			this.allWallButtons.push(b);
		}
		this.setActiveWallButton(2, 1, true);
		this.el.addEventListener("keydown", this.keyboardHandler());
	}

	setActiveWallButton(x, y, noFocus) {
		if (x == 12) x = 10;
		this.activeWallButton = this.wallButtons[y][x];
		for (const b of this.allWallButtons) b.classList.remove('active');
		this.activeWallButton.classList.add('active');
		if (!noFocus) this.activeWallButton.focus();
	}

	keyboardHandler() {
		return e => {
			const x = parseInt(this.activeWallButton.dataset.x, 10),
				y = parseInt(this.activeWallButton.dataset.y, 10);
			switch (e.key) {
				case "ArrowRight": if (x < 10) this.setActiveWallButton(x + 2, y); break;
				case "ArrowLeft": if (x > 2) this.setActiveWallButton(x - 2, y); break;
				case "ArrowUp": if (y > 1) this.setActiveWallButton(x + 1 - 2 * (y & 1), y - 1); break;
				case "ArrowDown": if (y < 19) this.setActiveWallButton(x + 1 - 2 * (y & 1), y + 1); break;
				// strictly we don't need to handle space since it fires as a click handler anyway
				// but i think it's way less confusing if we do it explicitly here
				case " ": case "Space": this.toggleWall(x, y); break;
				default: console.log(e); return;
			}
			e.preventDefault();
		};
	}
}
